import React from 'react';
import { MultiSelect, Option } from '../../../../../../components/ui/multi-select';
import { CollapsibleFilterBar } from '../../materials/tabs/Filters/CollapsibleFilterBar';

interface EquipmentFilters {
  equipmentNumber: string[];
  equipmentName: string[];
  equipmentType: string[];
  serialNumber: string[];
}

interface EquipmentFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filters: EquipmentFilters;
  onFilterChange: (key: keyof EquipmentFilters) => (value: string[]) => void;
  uniqueEquipmentNumbers: string[];
  uniqueEquipmentNames: string[];
  uniqueEquipmentTypes: string[];
  uniqueSerialNumbers: string[];
  hasActiveFilters: boolean;
  filteredCount: number;
  onResetFilters: () => void;
}

export const EquipmentFilters: React.FC<EquipmentFiltersProps> = ({
  searchQuery,
  onSearchChange,
  filters,
  onFilterChange,
  uniqueEquipmentTypes,
  uniqueSerialNumbers,
  filteredCount,
  onResetFilters,
}) => {
  const equipmentTypeOptions: Option[] = uniqueEquipmentTypes.map((eqType) => ({
    value: eqType,
    label: eqType,
  }));

  const serialNumberOptions: Option[] = uniqueSerialNumbers.map((serialNum) => ({
    value: serialNum,
    label: serialNum,
  }));

  const activeFilterCount = filters.equipmentType.length + filters.serialNumber.length;

  return (
    <CollapsibleFilterBar
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search equipment by name, number, or comments..."
      activeFilterCount={activeFilterCount}
      filteredCount={filteredCount}
      filteredCountLabel="equipment"
      onResetFilters={onResetFilters}
    >
      <MultiSelect
        options={equipmentTypeOptions}
        selected={filters.equipmentType}
        onChange={onFilterChange('equipmentType')}
        placeholder="Equipment Type"
      />
      <MultiSelect
        options={serialNumberOptions}
        selected={filters.serialNumber}
        onChange={onFilterChange('serialNumber')}
        placeholder="Serial Number"
      />
    </CollapsibleFilterBar>
  );
};
